<template>
	<div class="police-solution-page">
		<Head />
		<main class="police-main">
			<section class="hero section-py">
				<div class="container-custom hero-grid">
					<div>
						<div class="hero-badge">公安系统心理健康专项解决方案</div>
						<h1>公安民警心理测评系统</h1>
						<p>
							以<span>全警覆盖·精准筛查·智能预警·闭环干预</span>为核心，应对公安“五高”职业环境，落实从优待警、从严治警要求，构建常态化心理服务机制。
						</p>
						<div class="hero-actions">
							<a href="#contact" class="btn-primary">获取政务专属方案</a>
							<a href="#function" class="btn-outline">查看核心功能</a>
						</div>
						<div class="hero-points">
							<div><i class="el-icon-success"></i>三级预警机制</div>
							<div><i class="el-icon-success"></i>一人一档管理</div>
							<div><i class="el-icon-success"></i>等保三级认证</div>
						</div>
					</div>
					<div class="hero-image-wrap">
						<img src="https://picsum.photos/900/560?random=70" alt="公安民警心理测评系统管理后台">
					</div>
				</div>
			</section>

			<section id="general" class="section-py">
				<div class="container-custom">
					<div class="section-head">
						<h2>方案总则</h2>
						<div class="title-underline"></div>
						<p>明确背景、依据与原则，构建科学规范的公安民警心理健康服务体系。</p>
					</div>
					<div class="two-grid">
						<div class="card card-hover">
							<h3 class="gradient-text">方案背景与指导思想</h3>
							<div class="stack-list">
								<div v-for="item in backgroundList" :key="item.title" class="stack-item">
									<h4>{{ item.title }}</h4>
									<p>{{ item.desc }}</p>
								</div>
							</div>
						</div>
						<div class="card card-hover">
							<h3 class="gradient-text">核心建设原则</h3>
							<div class="principle-grid">
								<div v-for="item in principleList" :key="item.title" class="principle-item">
									<h4>{{ item.title }}</h4>
									<p>{{ item.desc }}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>

			<section id="organization" class="section-py section-soft">
				<div class="container-custom">
					<div class="section-head">
						<h2>组织架构与职责分工</h2>
						<div class="title-underline"></div>
						<p>明确三级组织架构，压实职责，确保系统高效落地运行。</p>
					</div>
					<div class="three-grid">
						<div v-for="item in organizationList" :key="item.title" class="card card-hover">
							<div class="icon-wrap"><i :class="item.icon"></i></div>
							<h3>{{ item.title }}</h3>
							<p>{{ item.desc }}</p>
						</div>
					</div>
				</div>
			</section>

			<section id="assessment" class="section-py">
				<div class="container-custom">
					<div class="section-head">
						<h2>测评体系</h2>
						<div class="title-underline"></div>
						<p>分类测评对象 + 多维度量表库，实现精准化、差异化心理评估。</p>
					</div>
					<div class="two-grid">
						<div class="card card-hover">
							<h3 class="gradient-text">测评对象与频次标准</h3>
							<ul class="desc-list">
								<li v-for="item in targetList" :key="item">{{ item }}</li>
							</ul>
						</div>
						<div class="card card-hover">
							<h3 class="gradient-text">量表与维度体系</h3>
							<div class="label-group">
								<div v-for="item in scaleGroups" :key="item.title" class="label-card">
									<h4>{{ item.title }}</h4>
									<div class="chips">
										<span v-for="tag in item.tags" :key="tag">{{ tag }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>

			<section id="function" class="section-py section-soft">
				<div class="container-custom">
					<div class="section-head">
						<h2>核心功能模块</h2>
						<div class="title-underline"></div>
						<p>全流程功能覆盖，满足公安系统多样化心理测评与管理需求。</p>
					</div>
					<div class="function-grid">
						<div v-for="item in functionList" :key="item.title" class="card card-hover">
							<h3>{{ item.title }}</h3>
							<ul class="desc-list">
								<li v-for="point in item.points" :key="point">{{ point }}</li>
							</ul>
						</div>
					</div>
				</div>
			</section>

			<section id="implementation" class="section-py">
				<div class="container-custom">
					<div class="section-head">
						<h2>实施流程与保障措施</h2>
						<div class="title-underline"></div>
						<p>规范流程 + 多重保障，确保系统安全落地、长效运行。</p>
					</div>
					<div class="two-grid">
						<div class="card card-hover">
							<h3 class="gradient-text">实施流程（六步闭环）</h3>
							<div class="step-list">
								<div v-for="(item, index) in implementationSteps" :key="item.title" class="step-item" style="margin-bottom: 20px;">
									<span>{{ `0${index + 1}`.slice(-2) }}</span>
									<div>
										<h4>{{ item.title }}</h4>
										<p>{{ item.desc }}</p>
									</div>
								</div>
							</div>
						</div>
						<div class="card card-hover">
							<h3 class="gradient-text">保密管理与落地保障</h3>
							<ul class="desc-list">
								<li v-for="item in securityList" :key="item">{{ item }}</li>
							</ul>
							<div class="safe-grid">
								<div v-for="item in safeguardList" :key="item.title" class="safe-item">
									<h4>{{ item.title }}</h4>
									<p>{{ item.desc }}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>

			<section class="result-section">
				<div class="container-custom result-box">
					<h2>预期建设成效</h2>
					<div class="result-grid">
						<div v-for="item in resultList" :key="item.title" class="result-card card-hover">
							<h3>{{ item.title }}</h3>
							<p>{{ item.desc }}</p>
						</div>
					</div>
					<!-- <a href="#contact" class="result-btn">立即咨询，获取公安系统专属方案</a> -->
				</div>
			</section>
			<SiteFooter />
		</main>
	</div>
</template>

<script>
	import Head from '@/components/head/index.vue'
	import SiteFooter from '@/components/footer/index.vue'

	export default {
		name: 'PoliceSolution',
		components: {
			Head,
			SiteFooter
		},
		data() {
			return {
				backgroundList: [{
						title: '方案背景：应对“五高”职业环境',
						desc: '公安队伍长期面临高风险、高负荷、高对抗、高压力、高期待，亟需系统化心理健康支撑。'
					},
					{
						title: '指导思想：落实从优待警',
						desc: '构建覆盖全警、标准统一、运行高效、安全规范的常态化心理服务机制。'
					}
				],
				principleList: [{
						title: '科学性原则',
						desc: '采用公安行业常模量表，流程规范结果可信。'
					},
					{
						title: '全员覆盖原则',
						desc: '覆盖在职民警、辅警、新警及重点岗位人员。'
					},
					{
						title: '闭环管理原则',
						desc: '测评-筛查-预警-干预-随访-归档全流程闭环。'
					},
					{
						title: '保密性原则',
						desc: '严格执行保密纪律，数据加密与权限分级。'
					},
					{
						title: '常态化原则',
						desc: '纳入年度体检、入警培训、晋升与重大任务保障。'
					},
					{
						title: '实施保障原则',
						desc: '确保心理健康服务体系规范化、长效化运行。'
					}
				],
				organizationList: [{
						title: '领导小组',
						desc: '统筹决策与资源保障，负责制度审批和高危事件处置。',
						icon: 'el-icon-s-home'
					},
					{
						title: '执行工作小组',
						desc: '承担测评组织、预警复核、干预实施与随访工作。',
						icon: 'el-icon-s-operation'
					},
					{
						title: '技术支持单位',
						desc: '负责系统部署、运维、安全加固、量表更新和培训支持。',
						icon: 'el-icon-setting'
					}
				],
				targetList: [
					'全员普测：覆盖全体在职民警、辅警，每年1-2次。',
					'重点必测：新警、岗位调整、重大任务前后、高应激岗位。',
					'专项测评：危机干预后复查、年度健康体检配套测评。'
				],
				scaleGroups: [{
						title: '基础心理健康筛查',
						tags: ['SCL-90', 'SDS', 'SAS', 'SRSS']
					},
					{
						title: '职业压力与倦怠',
						tags: ['MBI职业倦怠', '警务压力源', '职业认同', '工作投入度']
					},
					{
						title: '人格特质与应激',
						tags: ['16PF警务版', 'EPQ', 'PCL-5', '应激耐受']
					},
					{
						title: '专项场景测评',
						tags: ['新警适应', '岗位胜任力', '重大任务', '干预效果评估']
					}
				],
				functionList: [{
						title: '组织管理模块',
						points: ['支持市局-分局-所队-班组四级组织', '人员批量导入与脱敏管理', '5类分级权限设置保障安全']
					},
					{
						title: '多终端测评模块',
						points: ['支持PC、警务终端、微信端、自助机', '适配内外网并支持离线测评', '防作弊策略保证数据可信']
					},
					{
						title: '档案管理模块',
						points: ['建立一人一档终身电子档案', '覆盖测评、干预、随访全流程数据', '加密存储并支持合规导出']
					},
					{
						title: '报告生成模块',
						points: ['自动生成个人分析报告', '部门汇总和全局决策报告', '规范格式支持归档审计']
					},
					{
						title: '智能预警模块',
						points: ['红黄绿三级预警机制', '系统自动识别高危风险人员', '多角色实时推送确保及时处置']
					},
					{
						title: '干预与随访模块',
						points: ['分级干预方案与咨询预约', '随访计划与复诊提醒', '闭环销号管理全程可追溯']
					}
				],
				implementationSteps: [{
						title: '前期准备与宣导动员',
						desc: '制定测评计划，组织宣导并明确测评目的。'
					},
					{
						title: '集中测评（线上/线下）',
						desc: '按单位组织测评任务，确保全员覆盖。'
					},
					{
						title: '数据回收与自动筛查',
						desc: '系统回收并分析数据，初步识别风险等级。'
					},
					{
						title: '分级预警与分类处置',
						desc: '依据三级预警结果分级推送并启动处置。'
					},
					{
						title: '干预实施与跟踪随访',
						desc: '开展咨询辅导，持续评估干预效果。'
					},
					{
						title: '归档总结与优化提升',
						desc: '形成年度报告，持续优化后续测评方案。'
					}
				],
				securityList: [
					'数据加密管控：全程加密存储，符合等保三级标准。',
					'结果用途隔离：仅限心理健康服务使用。',
					'严格查阅权限：分级授权，操作全程留痕。',
					'违规严肃追责：严格执行保密纪律。'
				],
				safeguardList: [{
						title: '制度保障',
						desc: '制定管理办法、保密制度和干预预案。'
					},
					{
						title: '人员保障',
						desc: '配齐专职心理教官并培训兼职辅导员。'
					},
					{
						title: '场地保障',
						desc: '设立标准化心理健康服务室与咨询室。'
					},
					{
						title: '经费保障',
						desc: '保障建设、运维和培训经费投入。'
					},
					{
						title: '技术保障',
						desc: '7x12小时技术支持与周期性安全加固。'
					}
				],
				resultList: [{
						title: '构建全域管理体系',
						desc: '建成全警覆盖、全程闭环、全域预警的心理健康管理体系。'
					},
					{
						title: '强化风险预警干预',
						desc: '实现心理风险早发现、早干预，降低危机事件发生率。'
					},
					{
						title: '提升民警幸福感',
						desc: '增强队伍凝聚力与职业认同，提升情绪管理能力。'
					},
					{
						title: '增强队伍战斗力',
						desc: '为公安工作高质量发展提供坚实心理支撑。'
					}
				],
				contactPersons: [{
						name: '张先生',
						phone: '13161072501'
					},
					{
						name: '许女士',
						phone: '15031192537'
					},
					{
						name: '安先生',
						phone: '18932907651'
					}
				],
				consultationForm: {
					name: '',
					phone: '',
					org: '',
					dept: '',
					desc: ''
				}
			}
		},
		mounted() {
			this.scrollToHashTarget()
		},
		watch: {
			'$route.hash'() {
				this.scrollToHashTarget()
			}
		},
		methods: {
			scrollToHashTarget() {
				if (!this.$route.hash) return
				this.$nextTick(() => {
					const target = document.querySelector(this.$route.hash)
					if (target) {
						target.scrollIntoView({
							behavior: 'smooth',
							block: 'start'
						})
					}
				})
			},
			handleConsultSubmit() {
				window.alert('咨询信息提交成功！我们将在1个工作日内与您联系。')
				this.consultationForm = {
					name: '',
					phone: '',
					org: '',
					dept: '',
					desc: ''
				}
			}
		}
	}
</script>

<style scoped>
	.police-solution-page {
		min-height: 100vh;
		background: #f8fafc;
		color: #1a202c;
	}

	.police-main {
		padding-top: 64px;
	}

	.section-py {
		padding: 64px 0;
	}

	.section-soft {
		background: #f3f7fb;
	}

	.container-custom {
		max-width: 1260px;
		margin: 0 auto;
		padding: 0 20px;
	}

	.section-head {
		max-width: 780px;
		margin: 0 auto 40px;
		text-align: center;
	}

	.section-head h2 {
		margin: 0;
		font-size: clamp(30px, 4vw, 46px);
		line-height: 1.3;
	}

	.section-head p {
		margin: 0;
		font-size: 17px;
		line-height: 1.75;
		color: #5f6f82;
	}

	.title-underline {
		width: 66px;
		height: 5px;
		margin: 18px auto;
		border-radius: 999px;
		background: #3b82f6;
	}

	.hero {
		background: linear-gradient(135deg, rgba(15, 53, 87, 0.08) 0%, rgba(42, 90, 140, 0.08) 100%);
	}

	.hero-grid {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 30px;
		align-items: center;
	}

	.hero-badge {
		display: inline-block;
		padding: 8px 14px;
		margin-bottom: 10px;
		border-radius: 999px;
		font-size: 13px;
		color: #0f3557;
		background: rgba(15, 53, 87, 0.1);
	}

	.hero h1 {
		margin: 0 0 14px;
		font-size: clamp(34px, 5vw, 60px);
		line-height: 1.25;
	}

	.hero p {
		margin: 0;
		font-size: 18px;
		line-height: 1.75;
		color: #4b5563;
	}

	.hero p span {
		font-weight: 700;
		color: #0f3557;
	}

	.hero-actions {
		display: flex;
		flex-wrap: wrap;
		gap: 12px;
		margin: 24px 0 16px;
	}

	.btn-primary,
	.btn-outline {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		padding: 12px 24px;
		border-radius: 10px;
		font-size: 15px;
		font-weight: 600;
		text-decoration: none;
		border: 1px solid transparent;
		cursor: pointer;
	}

	.btn-primary {
		background: #0f3557;
		border-color: #0f3557;
		color: #fff;
	}

	.btn-primary:hover {
		background: #0c2d49;
	}

	.btn-primary.full {
		width: 100%;
	}

	.btn-outline {
		color: #0f3557;
		border-color: #0f3557;
		background: transparent;
	}

	.btn-outline:hover {
		background: rgba(15, 53, 87, 0.06);
	}

	.hero-points {
		display: grid;
		grid-template-columns: repeat(3, minmax(0, 1fr));
		gap: 8px;
	}

	.hero-points div {
		display: inline-flex;
		align-items: center;
		gap: 6px;
		font-size: 14px;
		color: #4b5563;
	}

	.hero-points i {
		color: #0f3557;
	}

	.hero-image-wrap {
		background: #fff;
		padding: 10px;
		border-radius: 16px;
		border: 1px solid #d7e3ef;
		box-shadow: 0 12px 28px rgba(15, 53, 87, 0.14);
	}

	.hero-image-wrap img {
		display: block;
		width: 100%;
		height: auto;
		border-radius: 10px;
	}

	.two-grid {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 18px;
	}

	.three-grid {
		display: grid;
		grid-template-columns: repeat(3, minmax(0, 1fr));
		gap: 16px;
	}

	.card,
	.contact-form {
		background: #fff;
		border: 1px solid #dbe7f3;
		border-radius: 14px;
		padding: 22px 18px;
		box-shadow: 0 4px 16px rgba(15, 53, 87, 0.08);
	}

	.card-hover {
		transition: all 0.35s ease;
	}

	.card-hover:hover {
		transform: translateY(-6px);
		box-shadow: 0 10px 24px rgba(15, 53, 87, 0.12);
	}

	.gradient-text {
		margin: 0 0 14px;
		font-size: 24px;
		background: linear-gradient(90deg, #0f3557, #3b82f6);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		background-clip: text;
		color: transparent;
	}

	.stack-list,
	.principle-grid,
	.step-list,
	.safe-grid {
		display: flex;
		flex-direction: column;
		gap: 10px;
	}

	.stack-item {
		padding-left: 12px;
		border-left: 4px solid #0f3557;
	}

	.stack-item h4,
	.principle-item h4,
	.step-item h4,
	.safe-item h4,
	.label-card h4 {
		margin: 0;
		font-size: 17px;
	}

	.stack-item p,
	.principle-item p,
	.step-item p,
	.safe-item p,
	.label-card p,
	.result-card p {
		margin: 4px 0 0;
		font-size: 14px;
		line-height: 1.7;
		color: #5f6f82;
	}

	.principle-item,
	.safe-item,
	.label-card {
		padding: 10px;
		border-radius: 10px;
		border: 1px solid #e2edf8;
		background: #f7fafe;
	}

	.icon-wrap {
		width: 52px;
		height: 52px;
		border-radius: 12px;
		background: rgba(15, 53, 87, 0.1);
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 10px;
	}

	.icon-wrap i {
		font-size: 26px;
		color: #0f3557;
	}

	.card h3 {
		margin: 0 0 10px;
		font-size: 22px;
	}

	.desc-list {
		margin: 0;
		padding: 0;
		list-style: none;
	}

	.desc-list li {
		position: relative;
		padding-left: 12px;
		margin-bottom: 10px;
		font-size: 14px;
		line-height: 1.7;
		color: #5f6f82;
	}

	.desc-list li::before {
		content: '•';
		position: absolute;
		left: 0;
		color: #0f3557;
	}

	.label-group {
		display: flex;
		flex-direction: column;
		gap: 10px;
	}

	.chips {
		display: flex;
		flex-wrap: wrap;
		gap: 8px;
		margin-top: 8px;
	}

	.chips span {
		padding: 4px 10px;
		font-size: 12px;
		border-radius: 999px;
		background: #fff;
		border: 1px solid #d8e5f3;
		color: #4b5563;
	}

	.function-grid {
		display: grid;
		grid-template-columns: repeat(3, minmax(0, 1fr));
		gap: 16px;
	}

	.step-item {
		display: flex;
		gap: 8px;
		align-items: flex-start;
	}

	.step-item span {
		width: 28px;
		height: 28px;
		border-radius: 50%;
		background: #0f3557;
		color: #fff;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		font-size: 12px;
		font-weight: 700;
		flex-shrink: 0;
	}

	.safe-grid {
		margin-top: 10px;
	}

	.result-section {
		padding: 58px 0;
		background: linear-gradient(90deg, #0f3557 0%, #2a5a8c 100%);
	}

	.result-box {
		max-width: 980px;
		text-align: center;
	}

	.result-box h2 {
		margin: 0 0 18px;
		font-size: 34px;
		color: #fff;
	}

	.result-grid {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 14px;
		margin-bottom: 20px;
	}

	.result-card {
		padding: 18px 14px;
		border-radius: 12px;
		background: rgba(255, 255, 255, 0.12);
		border: 1px solid rgba(255, 255, 255, 0.3);
	}

	.result-card h3 {
		margin: 0 0 8px;
		font-size: 20px;
		color: #fff;
	}

	.result-card p {
		color: rgba(255, 255, 255, 0.9);
	}

	.result-btn {
		display: inline-flex;
		padding: 12px 24px;
		border-radius: 10px;
		background: #fff;
		color: #0f3557;
		font-weight: 700;
		text-decoration: none;
	}

	.contact-grid {
		display: grid;
		grid-template-columns: 2fr 1fr;
		gap: 18px;
	}

	.contact-form {
		background: #f8fafc;
	}

	.form-grid {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 12px;
	}

	.form-item {
		margin-bottom: 12px;
	}

	.form-item label {
		display: block;
		margin-bottom: 6px;
		font-size: 14px;
		color: #374151;
	}

	.form-item input,
	.form-item select,
	.form-item textarea {
		width: 100%;
		box-sizing: border-box;
		padding: 10px 12px;
		font-size: 14px;
		border: 1px solid #d5e0ec;
		border-radius: 8px;
		outline: none;
	}

	.form-item input:focus,
	.form-item select:focus,
	.form-item textarea:focus {
		border-color: #2a5a8c;
		box-shadow: 0 0 0 3px rgba(42, 90, 140, 0.16);
	}

	.contact-aside {
		border-radius: 14px;
		padding: 24px 20px;
		color: #fff;
		background: linear-gradient(135deg, #0f3557 0%, #2a5a8c 100%);
	}

	.contact-aside h3 {
		margin: 0 0 18px;
		font-size: 30px;
	}

	.person-list {
		display: flex;
		flex-direction: column;
		gap: 12px;
	}

	.person-item {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.person-icon {
		width: 42px;
		height: 42px;
		border-radius: 50%;
		background: rgba(255, 255, 255, 0.2);
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.person-name {
		margin: 0 0 2px;
		font-size: 13px;
		opacity: 0.82;
	}

	.person-phone {
		margin: 0;
		font-size: 20px;
		font-weight: 600;
	}

	.company {
		margin-top: 20px;
		padding-top: 12px;
		border-top: 1px solid rgba(255, 255, 255, 0.25);
	}

	.company p {
		margin: 0 0 4px;
		font-size: 13px;
		opacity: 0.82;
	}

	.company h4 {
		margin: 0;
		font-size: 20px;
	}

	@media (max-width: 1200px) {

		.function-grid,
		.three-grid {
			grid-template-columns: repeat(2, minmax(0, 1fr));
		}
	}

	@media (max-width: 992px) {
		.police-main {
			padding-top: 56px;
		}

		.section-py {
			padding: 48px 0;
		}

		.hero-grid,
		.two-grid,
		.contact-grid {
			grid-template-columns: 1fr;
		}

		.hero-points {
			grid-template-columns: 1fr;
		}
	}

	@media (max-width: 768px) {
		.container-custom {
			padding: 0 14px;
		}

		.section-py {
			padding: 34px 0;
		}

		.form-grid,
		.function-grid,
		.three-grid,
		.result-grid {
			grid-template-columns: 1fr;
		}

		.hero h1 {
			font-size: 32px;
		}

		.hero p,
		.section-head p {
			font-size: 14px;
		}
	}
</style>